export default __webpack_public_path__ + "static/media/objects-messages.a94d6679.svg";